import React from 'react'
import Header from '@/layout/header'
import Footer from '@/layout/footer'
import { NextSeo } from 'next-seo'
import { useRouter } from 'next/router';
import toast, { Toaster } from 'react-hot-toast';


export default function Layout({ children }) {
  const router = useRouter();

  const getSeoTitle = () => {
    const pathArray = router.asPath.split('/').filter(Boolean);
    if (pathArray.length === 0) { return 'NICDC'; }
    const lastSegment = pathArray[pathArray.length - 1];
    return `${capitalizeFirstLetter(lastSegment.replace(/-/g, ' '))} | NICDC`;
  };

  const capitalizeFirstLetter = (string) => string.split(' ').map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()).join(' ');


  return (
    <div className=''>
      <NextSeo title={getSeoTitle()} />
      <Header />
      <Toaster position="top-right" />
      <div>{children}</div>
      <Footer />
    </div>
  )
}
